(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carverall-quick-start"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.cv-qs');

    sections.forEach((section) => {
      const filterButtons = section.querySelectorAll('[data-qs-machine]');
      const items = section.querySelectorAll('[data-qs-item]');
      const machineCards = section.querySelectorAll('.cv-qs__machine-button');
      const dialog = section.querySelector('[data-video-dialog]');
      const frame = section.querySelector('[data-video-frame]');

      const setFilter = (machine) => {
        filterButtons.forEach((button) => {
          button.classList.toggle('is-active', button.dataset.qsMachine === machine);
        });

        machineCards.forEach((button) => {
          button.classList.toggle('is-active', button.dataset.qsMachine === machine);
        });

        items.forEach((item) => {
          const shouldShow = machine === 'all' || item.dataset.machine === machine || item.dataset.machine === 'all';
          item.classList.toggle('is-hidden', !shouldShow);
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => setFilter(button.dataset.qsMachine));
      });

      const embedUrl = (url) => {
        if (!url) return '';
        if (url.includes('/embed/')) return url;
        const watchMatch = url.match(/[?&]v=([^&]+)/);
        if (watchMatch && watchMatch[1]) return `https://www.youtube.com/embed/${watchMatch[1]}`;
        const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
        if (shortMatch && shortMatch[1]) return `https://www.youtube.com/embed/${shortMatch[1]}`;
        return url;
      };

      section.querySelectorAll('[data-video-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const url = embedUrl(button.dataset.videoUrl);
          if (!url) return;

          frame.innerHTML = `<iframe src="${url}?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Tutorial video"></iframe>`;

          if (dialog.showModal) {
            dialog.showModal();
          }
        });
      });

      section.querySelectorAll('[data-video-close]').forEach((button) => {
        button.addEventListener('click', () => {
          frame.innerHTML = '';
          dialog.close();
        });
      });

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            frame.innerHTML = '';
            dialog.close();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carverall-user-guides"] && !Shopify.designMode) return;
  try {
    
  const guideSections = document.querySelectorAll("[data-carverall-guides]");

  guideSections.forEach((section) => {
    const form = section.querySelector("[data-guides-search-form]");
    const search = section.querySelector("[data-guides-search]");
    const clear = section.querySelector("[data-guides-clear]");
    const filters = section.querySelectorAll("[data-guides-filter]");
    const cards = section.querySelectorAll("[data-guide-card]");
    const count = section.querySelector("[data-guides-count]");
    const empty = section.querySelector("[data-guides-empty]");
    let activeFilter = "all";

    const updateCards = () => {
      const query = search ? search.value.trim().toLowerCase() : "";
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesFilter = activeFilter === "all" || card.dataset.guideCategory === activeFilter;
        const matchesSearch = !query || card.dataset.guideSearch.includes(query);
        const isVisible = matchesFilter && matchesSearch;
        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (count) {
        count.textContent = visibleCount === 1 ? "Showing 1 guide" : `Showing ${visibleCount} guides`;
      }

      if (clear) {
        clear.hidden = !query;
      }

      if (empty) {
        empty.hidden = visibleCount > 0;
      }
    };

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        updateCards();
      });
    }

    if (search) {
      search.addEventListener("input", updateCards);
      search.addEventListener("search", updateCards);
    }

    if (clear && search) {
      clear.addEventListener("click", () => {
        search.value = "";
        updateCards();
        search.focus();
      });
    }

    filters.forEach((button) => {
      button.addEventListener("click", () => {
        activeFilter = button.dataset.guidesFilter;
        filters.forEach((filter) => filter.classList.toggle("is-active", filter === button));
        updateCards();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g6-uv-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-g6-slider]').forEach((slider) => {
    if (slider.dataset.g6SliderReady === 'true') return;
    slider.dataset.g6SliderReady = 'true';
    const track = slider.querySelector('[data-g6-slider-track]');
    const slides = Array.from(slider.querySelectorAll('[data-g6-slide]'));
    const previous = slider.querySelector('[data-g6-slider-prev]');
    const next = slider.querySelector('[data-g6-slider-next]');
    const count = slider.querySelector('[data-g6-slider-count]');
    const dots = Array.from(slider.querySelectorAll('[data-g6-slider-dot]'));
    let active = 0;
    const updateControls = () => {
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };
    const move = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[active].offsetLeft, behavior: 'smooth' });
      updateControls();
    };
    if (previous) previous.addEventListener('click', () => move(active - 1));
    if (next) next.addEventListener('click', () => move(active + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => move(Number(dot.dataset.slideIndex))));
    track.addEventListener('scroll', () => {
      let closest = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const nextDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (nextDistance < distance) {
          closest = index;
          distance = nextDistance;
        }
      });
      active = closest;
      updateControls();
    }, { passive: true });
    updateControls();
    if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(() => move(active + 1), 6000);
    }
  });
  const initLaserTabs = (scope = document) => {
    scope.querySelectorAll('[data-g6-laser-tabs]').forEach((root) => {
      if (root.dataset.g6LaserTabsReady === 'true') return;
      root.dataset.g6LaserTabsReady = 'true';
      const groupTabs = Array.from(root.querySelectorAll('[data-g6-laser-group-tab]'));
      const groupPanels = Array.from(root.querySelectorAll('[data-g6-laser-group-panel]'));

      const activateMaterial = (groupPanel, materialId, focus = false) => {
        const materialTabs = Array.from(groupPanel.querySelectorAll('[data-g6-material-tab]'));
        const materialPanels = Array.from(groupPanel.querySelectorAll('[data-g6-material-panel]'));
        materialTabs.forEach((tab) => {
          const selected = tab.dataset.g6MaterialTab === materialId;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        materialPanels.forEach((panel) => {
          panel.hidden = panel.dataset.g6MaterialPanel !== materialId;
        });
      };

      const activateGroup = (groupId, focus = false) => {
        groupTabs.forEach((tab) => {
          const selected = tab.dataset.g6LaserGroupTab === groupId;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        groupPanels.forEach((panel) => {
          const selected = panel.dataset.g6LaserGroupPanel === groupId;
          panel.hidden = !selected;
          if (selected) {
            const activeMaterial = panel.querySelector('[data-g6-material-tab][aria-selected="true"]') || panel.querySelector('[data-g6-material-tab]');
            if (activeMaterial) activateMaterial(panel, activeMaterial.dataset.g6MaterialTab);
          }
        });
      };

      const bindArrowKeys = (tabs, activate) => {
        tabs.forEach((tab, index) => {
          tab.addEventListener('keydown', (event) => {
            let targetIndex = index;
            if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') targetIndex = 0;
            if (event.key === 'End') targetIndex = tabs.length - 1;
            if (targetIndex === index && !['Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            activate(tabs[targetIndex], true);
          });
        });
      };

      groupTabs.forEach((tab) => tab.addEventListener('click', () => activateGroup(tab.dataset.g6LaserGroupTab)));
      bindArrowKeys(groupTabs, (tab, focus) => activateGroup(tab.dataset.g6LaserGroupTab, focus));
      groupPanels.forEach((groupPanel) => {
        const materialTabs = Array.from(groupPanel.querySelectorAll('[data-g6-material-tab]'));
        materialTabs.forEach((tab) => tab.addEventListener('click', () => activateMaterial(groupPanel, tab.dataset.g6MaterialTab)));
        bindArrowKeys(materialTabs, (tab, focus) => activateMaterial(groupPanel, tab.dataset.g6MaterialTab, focus));
      });
    });
  };

  const initApplicationVideos = (scope = document) => {
    scope.querySelectorAll('[data-g6-video-modal]').forEach((modal) => {
      if (modal.dataset.g6VideoModalReady === 'true') return;
      modal.dataset.g6VideoModalReady = 'true';
      const section = modal.closest('.g6-showcase__applications-section');
      const frame = modal.querySelector('[data-g6-video-frame]');
      const closeButtons = Array.from(modal.querySelectorAll('[data-g6-video-close]'));
      const triggers = section ? Array.from(section.querySelectorAll('[data-g6-video-open]')) : [];
      let lastTrigger = null;

      const closeModal = () => {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        frame.replaceChildren();
        document.body.style.removeProperty('overflow');
        if (lastTrigger) lastTrigger.focus();
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const videoId = trigger.dataset.videoId;
          const videoType = trigger.dataset.videoType;
          if (!videoId) return;
          const iframe = document.createElement('iframe');
          iframe.title = trigger.getAttribute('aria-label') || 'Application video';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.src = videoType === 'vimeo'
            ? `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1`
            : `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          frame.replaceChildren(iframe);
          lastTrigger = trigger;
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          modal.querySelector('.g6-showcase__video-modal-close')?.focus();
        });
      });

      closeButtons.forEach((button) => button.addEventListener('click', closeModal));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  };

  initLaserTabs();
  initApplicationVideos();

  document.addEventListener('shopify:section:load', (event) => {
    initLaserTabs(event.target);
    initApplicationVideos(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const materialPanel = document.querySelector(`[data-material-block-id="${CSS.escape(event.detail.blockId)}"]`);
    if (!materialPanel) return;
    const root = materialPanel.closest('[data-g6-laser-tabs]');
    const groupPanel = materialPanel.closest('[data-g6-laser-group-panel]');
    root?.querySelector(`[data-g6-laser-group-tab="${groupPanel.dataset.g6LaserGroupPanel}"]`)?.click();
    root?.querySelector(`[data-g6-material-tab="${event.detail.blockId}"]`)?.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    const cartPage = document.getElementById('main-cart') || document.body;
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }

    const syncProtectionToggle = function(toggle) {
      const isChecked = toggle.classList.contains('checked');
      const label = toggle.querySelector('.xcotton-widget-title');

      toggle.setAttribute('role', 'switch');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-checked', String(isChecked));

      if(label) {
        const nextLabel = isChecked ? cartPage.dataset.protectionAddedLabel : cartPage.dataset.protectionAddLabel;
        if(label.textContent !== nextLabel) {
          label.textContent = nextLabel;
        }
        label.setAttribute('aria-live', 'polite');
      }
    };

    const enhanceProtectionToggle = function(toggle) {
      if(toggle.dataset.carverallEnhanced === 'true') {
        syncProtectionToggle(toggle);
        return;
      }

      toggle.dataset.carverallEnhanced = 'true';
      syncProtectionToggle(toggle);

      toggle.addEventListener('keydown', function(event) {
        if(event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle.click();
      });

      toggle.addEventListener('click', function() {
        window.requestAnimationFrame(function() {
          syncProtectionToggle(toggle);
        });
      });

      new MutationObserver(function() {
        syncProtectionToggle(toggle);
      }).observe(toggle, { attributes: true, attributeFilter: ['class'] });
    };

    const enhanceProtectionToggles = function() {
      document.querySelectorAll('.xcotton-content-title').forEach(enhanceProtectionToggle);
    };

    enhanceProtectionToggles();
    new MutationObserver(enhanceProtectionToggles).observe(cartPage, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z12-native-feature-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('z12-native-feature-tabs')) {
    customElements.define('z12-native-feature-tabs', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this._events) return;
          this.tabs = Array.from(this.querySelectorAll('[data-z12ft-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-z12ft-panel]'));
          this.tablist = this.querySelector('[data-z12ft-tablist]');
          if (!this.tabs.length || this.tabs.length !== this.panels.length || !this.tablist) return;

          this.autoEnabled = this.hasAttribute('data-z12ft-auto');
          this._events = new AbortController();
          const options = { signal: this._events.signal };
          this.tablist.setAttribute('role', 'tablist');
          this.tablist.setAttribute('aria-orientation', 'vertical');
          this.tabs.forEach((tab, index) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', this.panels[index].id);
            this.panels[index].setAttribute('role', 'tabpanel');
            this.panels[index].setAttribute('aria-labelledby', tab.id);
            this.panels[index].tabIndex = 0;
            const description = tab.querySelector('[data-z12ft-description]');
            if (description) this.panels[index].setAttribute('aria-describedby', description.id);
            tab.addEventListener('click', (event) => {
              event.preventDefault();
              this.activate(index, true);
            }, options);
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index), options);
          });
          document.addEventListener('shopify:block:select', (event) => {
            if (!this.contains(event.target)) return;
            const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail?.blockId);
            if (index !== -1) this.activate(index, true);
          }, options);

          const previous = this.tabs.findIndex((tab) => tab.dataset.blockId === this.dataset.activeBlock);
          this.activate(previous === -1 ? 0 : previous);
          this.setAttribute('data-enhanced', '');
          if (this.autoEnabled) {
            this.initAuto(options);
            this._structureObserver = new MutationObserver(records => {
              if (!records.some(record => record.target === this || record.target.matches?.('.z12ft__inner,.z12ft__layout,.z12ft__media,[data-z12ft-tablist]'))) return;
              this.disconnectedCallback();
              if (this.isConnected) this.connectedCallback();
            });
            this._structureObserver.observe(this, { childList: true, subtree: true });
          }
        });
      }

      activate(index, explicit = false) {
        if (!this.tabs[index]) return;
        if (this.autoEnabled) {
          if (this.autoIndex !== index) this.releaseAuto();
          if (explicit || this.autoIndex !== index) { this.autoPaused = false; this.autoSuppressed = false; }
          this.autoIndex = index;
        }
        const template = this.panels[index].querySelector('template[data-z12ft-image]');
        if (template && !this.autoEnabled) template.replaceWith(template.content.cloneNode(true));
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          tab.querySelectorAll('[data-z12ft-detail]').forEach((detail) => { detail.hidden = !selected; });
          const panel = this.panels[position];
          if (!selected) this.pauseMedia(panel);
          panel.hidden = !selected;
          if (this.autoEnabled) panel.inert = !selected;
          if (selected) panel.querySelectorAll('iframe[data-z12ft-src]').forEach((frame) => {
            if (!frame.hasAttribute('src')) frame.setAttribute('src', frame.dataset.z12ftSrc);
          });
        });
        this.dataset.activeBlock = this.tabs[index].dataset.blockId;
        if (this.autoEnabled) this.syncAuto();
      }

      pauseMedia(panel) {
        if (this.autoEnabled) {
          if (this.autoMedia && panel.contains(this.autoMedia)) this.releaseAuto();
          return;
        }
        panel.querySelectorAll('video').forEach((video) => video.pause());
        panel.querySelectorAll('iframe').forEach((frame) => {
          if (!frame.hasAttribute('src')) return;
          frame.dataset.z12ftSrc = frame.getAttribute('src');
          frame.removeAttribute('src');
        });
      }

      onKeydown(event, index) {
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.activate(index, true);
          return;
        } else return;
        event.preventDefault();
        this.tabs.forEach((tab, position) => { tab.tabIndex = position === next ? 0 : -1; });
        this.tabs[next].focus();
      }


      initAuto(options) {
        this.autoVisible = false;
        const target = this.querySelector('.z12ft__media') || this;
        document.addEventListener('visibilitychange', () => this.syncAuto(), options);
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-z12ft-auto-play]');
          if (!button || !this.contains(button)) return;
          this.autoPaused = false; this.autoSuppressed = false;
          this.syncAuto();
        }, options);
        window.addEventListener('message', event => {
          const media = this.autoMedia;
          if (!media || media.tagName !== 'IFRAME' || event.source !== media.contentWindow) return;
          if (!['https://www.youtube.com','https://www.youtube-nocookie.com','https://player.vimeo.com'].includes(event.origin)) return;
          let payload = event.data;
          try { if (typeof payload === 'string') payload = JSON.parse(payload); } catch (_) { return; }
          if (payload?.event === 'onStateChange') {
            if (payload.info === 2) this.autoPaused = true;
            if (payload.info === 1) this.autoPaused = false;
          }
          if (payload?.event === 'pause') this.autoPaused = true;
          if (payload?.event === 'play') this.autoPaused = false;
        }, options);
        if ('IntersectionObserver' in window) {
          this.autoObserver = new IntersectionObserver(entries => {
            const entry = entries[entries.length - 1];
            const visible = this.autoVisible ? entry.isIntersecting && entry.intersectionRatio > .05 : entry.isIntersecting && entry.intersectionRatio >= .25;
            if (visible !== this.autoVisible) {
              this.autoVisible = visible;
              if (visible) { this.autoPaused = false; this.autoSuppressed = false; }
            }
            this.syncAuto();
          }, { threshold: [0, .05, .25] });
          this.autoObserver.observe(target);
        } else {
          const measure = () => {
            const box = target.getBoundingClientRect();
            const shown = Math.min(innerHeight, box.bottom) - Math.max(0, box.top);
            const visible = this.autoVisible ? shown > Math.min(box.height, innerHeight) * .05 : shown >= Math.min(box.height, innerHeight) * .25;
            if (visible !== this.autoVisible) { this.autoVisible = visible; if (visible) this.autoPaused = false; }
            this.syncAuto();
          };
          window.addEventListener('scroll', measure, { ...options, passive: true });
          window.addEventListener('resize', measure, { ...options, passive: true });
          measure();
        }
      }
      syncAuto() {
        clearTimeout(this.autoTimer);
        if (!this.autoEnabled || !this.autoVisible || document.hidden || !this.isConnected) { this.releaseAuto(); return; }
        if (this.autoPaused || this.autoSuppressed || this.autoMedia) return;
        this.autoTimer = setTimeout(() => this.mountAuto(), 140);
      }
      mountAuto() {
        if (!this.autoVisible || document.hidden || !this.isConnected || this.autoPaused || this.autoSuppressed || this.autoMedia) return;
        const panel = this.panels[this.autoIndex];
        const template = panel?.querySelector('template[data-z12ft-image]');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        const media = fragment.querySelector('video,iframe');
        if (!media) return;
        const previous = window.z12ActiveFeatureAuto;
        if (previous && previous !== this) { previous.autoSuppressed = true; previous.releaseAuto(); }
        window.z12ClaimMedia?.(this, () => { this.autoSuppressed = true; this.releaseAuto(); });
        window.z12ActiveFeatureAuto = this;
        media.dataset.z12ftManaged = '';
        this.autoMedia = media;
        const stage = panel.querySelector('[data-z12ft-image-stage]');
        if (media.tagName === 'VIDEO') {
          media.muted = true; media.defaultMuted = true;
          media.setAttribute('muted',''); media.playsInline = true;
          media.setAttribute('playsinline',''); media.controls = true; media.preload = 'none';
          media.addEventListener('pause', () => { if (this.autoMedia === media && !media.ended) this.autoPaused = true; }, { signal: this._events.signal });
          media.addEventListener('play', () => { if (this.autoMedia === media) this.autoPaused = false; }, { signal: this._events.signal });
        } else {
          const url = new URL(media.getAttribute('src'), location.href);
          const youtube = url.hostname.includes('youtube');
          url.searchParams.set('autoplay','1');
          url.searchParams.set(youtube ? 'mute' : 'muted','1');
          url.searchParams.set('playsinline','1'); url.searchParams.set('controls','1');
          if (youtube) url.searchParams.set('enablejsapi','1');
          media.src = url.toString(); media.setAttribute('allow','autoplay; fullscreen; picture-in-picture; encrypted-media');
          media.addEventListener('load', () => {
            if (this.autoMedia !== media) return;
            const origin = new URL(media.src).origin;
            const message = youtube ? {event:'command',func:'addEventListener',args:['onStateChange']} : {method:'addEventListener',value:'pause'};
            media.contentWindow?.postMessage(JSON.stringify(message), origin);
          }, { once: true, signal: this._events.signal });
        }
        stage.append(fragment);
        panel.querySelectorAll('[data-z12ft-auto-play]').forEach(button => { button.hidden = true; });
        panel.querySelectorAll('[data-z12ft-auto-poster]').forEach(image => { image.hidden = true; });
        if (media.tagName === 'VIDEO') {
          const result = media.play();
          result?.catch(() => { if (this.autoMedia === media) this.autoPaused = true; });
        }
      }
      releaseAuto() {
        window.z12ReleaseMedia?.(this);
        clearTimeout(this.autoTimer);
        const media = this.autoMedia;
        this.autoMedia = null;
        if (window.z12ActiveFeatureAuto === this) window.z12ActiveFeatureAuto = null;
        if (media) {
          if (media.tagName === 'VIDEO') {
            media.pause(); media.removeAttribute('src');
            media.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
            media.load();
          } else media.removeAttribute('src');
          media.remove();
        }
        this.querySelectorAll('[data-z12ft-auto-poster]').forEach(image => { image.hidden = false; });
        this.querySelectorAll('[data-z12ft-auto-play]').forEach(button => { button.hidden = false; });
      }

      disconnectedCallback() {
        this._structureObserver?.disconnect(); this._structureObserver = null;
        this.autoObserver?.disconnect(); this.autoObserver = null;
        this.releaseAuto(); this.autoVisible = false;
        this.querySelectorAll('[data-z12ft-panel]').forEach((panel) => this.pauseMedia(panel));
        this._events?.abort();
        this._events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z12-native-hero"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('z12n-landing-buybar')) {
    customElements.define('z12n-landing-buybar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.bar = this.querySelector('.z12n-landing-buybar');
        if (!this.bar) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal, passive: true };
        this.header = document.querySelector('.section-header .header');
        this.headerSection = document.querySelector('.section-header');
        this.originalStyle = this.bar.getAttribute('style');
        this.bar.setAttribute('data-z12n-fixed-buybar', '');
        document.body.append(this.bar);
        this.animateUntil = 0;
        this.setBarHeight = () => {
          const height = this.bar.offsetHeight;
          if (height !== this.lastHeight) { this.lastHeight = height; this.style.height = height + 'px'; }
        };
        this.update = time => {
          this.frame = null;
          const bottom = this.header ? Math.max(0, this.header.getBoundingClientRect().bottom) : 0;
          const top = Math.round(bottom * 10) / 10;
          if (top !== this.lastTop) { this.lastTop = top; this.bar.style.setProperty('--z12n-buybar-top', top + 'px'); }
          if (time < this.animateUntil) this.frame = requestAnimationFrame(this.update);
        };
        this.schedule = (animate = false) => {
          if (animate) this.animateUntil = performance.now() + 550;
          if (!this.frame) this.frame = requestAnimationFrame(this.update);
        };
        window.addEventListener('scroll', () => this.schedule(), options);
        window.addEventListener('resize', () => this.schedule(), options);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', () => this.schedule(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => { this.setBarHeight(); this.schedule(); });
          this.resizeObserver.observe(this.bar);
          if (this.header) this.resizeObserver.observe(this.header);
        }
        if (this.headerSection) {
          this.headerObserver = new MutationObserver(() => this.schedule(true));
          this.headerObserver.observe(this.headerSection, { attributes: true, attributeFilter: ['class'] });
        }
        this.setBarHeight();
        this.schedule();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.headerObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.bar) {
          this.bar.removeAttribute('data-z12n-fixed-buybar');
          if (this.originalStyle === null) this.bar.removeAttribute('style');
          else this.bar.setAttribute('style', this.originalStyle);
          this.append(this.bar);
        }
        this.style.removeProperty('height');
        this.controller = null;
        this.frame = null;
      }
    });
  }

  if (!customElements.get('z12n-hero-film')) {
    customElements.define('z12n-hero-film', class Z12HeroFilm extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.opener = this.querySelector('[data-hero-film-open]');
        this.dialog = this.querySelector('dialog');
        this.mount = this.querySelector('[data-hero-film-mount]');
        this.template = this.querySelector('[data-hero-film-template]');
        if (!this.opener || !this.dialog || !this.mount || !this.template || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.opener.addEventListener('click', () => this.openFilm(), options);
        this.querySelector('[data-hero-film-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.clearFilm(true), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden && this.dialog.open) this.dialog.close(); }, options);
        this.opener.hidden = false;
      }
      openFilm() {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        const fragment = this.template.content.cloneNode(true);
        const frame = fragment.querySelector('iframe');
        if (frame && window.z12PlayRequestedMedia) { frame.dataset.videoSrc = frame.getAttribute('src'); frame.removeAttribute('src'); }
        this.mount.replaceChildren(fragment);
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.opener.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-hero-film-close]').focus({ preventScroll: true });
        const media = this.mount.querySelector('video,iframe');
        if (media && window.z12PlayRequestedMedia) window.z12PlayRequestedMedia(media, () => this.isConnected && this.dialog.open && !document.hidden, () => this.dialog.close());
        else if (media?.tagName === 'VIDEO') media.play().catch(() => { media.controls = true; });
      }
      clearFilm(restoreFocus) {
        if (!this.mount) return;
        this.mount.querySelectorAll('video,iframe').forEach(media => media.z12PlaybackCleanup?.());
        this.mount.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          video.load();
        });
        this.mount.replaceChildren();
        if (this.scrollLocked) {
          if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = this.previousOverflow;
          this.scrollLocked = false;
        }
        this.opener.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.clearFilm(false);
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z12-native-scenario-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('z12-scenario-carousel')) {
    customElements.define('z12-scenario-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController || this.frame) return;
        // Wait for child markup when a section is inserted by the theme editor.
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.frame = 0;
        if (!this.isConnected || this.abortController) return;
        this.track = this.querySelector('[data-z12sc-track]');
        this.cards = Array.from(this.querySelectorAll('[data-z12sc-card]'));
        this.previous = this.querySelector('[data-z12sc-previous]');
        this.next = this.querySelector('[data-z12sc-next]');
        this.controls = this.querySelector('[data-z12sc-controls]');
        this.status = this.querySelector('[data-z12sc-status]');
        if (!this.track || !this.cards.length || !this.previous || !this.next) return;

        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.previous.addEventListener('click', () => this.advance(-1), options);
        this.next.addEventListener('click', () => this.advance(1), options);
        this.track.addEventListener('scroll', () => this.queueUpdate(false), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          // A focused card link keeps its normal keyboard behavior.
          if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || this.maxScroll <= 1) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.advance((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.maxScroll);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.cards.find((card) => card.dataset.blockId === String(event.detail?.blockId));
          if (!selected) return;
          this.measure();
          this.goTo(this.positions[this.cards.indexOf(selected)].start, true);
          this.queueUpdate(false);
        }, options);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.queueUpdate(true));
          this.resizeObserver.observe(this.track);
          this.cards.forEach((card) => this.resizeObserver.observe(card));
        } else {
          window.addEventListener('resize', () => this.queueUpdate(true), { ...options, passive: true });
        }
        this.controls.hidden = this.cards.length < 2;
        this.measure();
        this.update();
      }

      queueUpdate(measure) {
        this.needsMeasure = this.needsMeasure || measure;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.isConnected || !this.abortController) return;
          if (this.needsMeasure) this.measure();
          this.update();
        });
      }

      measure() {
        this.needsMeasure = false;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.viewportWidth = this.track.clientWidth;
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.viewportWidth);
        const position = this.position();
        const bounds = this.track.getBoundingClientRect();
        this.positions = this.cards.map((card) => {
          const rect = card.getBoundingClientRect();
          const start = (this.rtl ? bounds.right - rect.right : rect.left - bounds.left) + position;
          return { start, end: start + rect.width };
        });
      }

      position() {
        return Math.max(0, Math.min(this.maxScroll, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft));
      }

      update() {
        const position = this.position();
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= this.maxScroll - 1;
        let first = this.positions.findIndex((card) => card.end > position + 1);
        if (first < 0) first = 0;
        let last = first;
        this.positions.forEach((card, index) => {
          if (card.start < position + this.viewportWidth - 1 && card.end > position + 1) last = index;
        });
        const message = (this.dataset.statusTemplate || '')
          .replaceAll('[first]', String(first + 1))
          .replaceAll('[last]', String(last + 1))
          .replaceAll('[total]', String(this.cards.length));
        if (this.status && this.status.textContent !== message) this.status.textContent = message;
      }

      advance(direction) {
        if (this.needsMeasure) this.measure();
        const position = this.position();
        const candidates = direction > 0 ? this.positions : [...this.positions].reverse();
        const target = candidates.find((card) => direction > 0 ? card.start > position + 2 : card.start < position - 2);
        this.goTo(target ? target.start : (direction > 0 ? this.maxScroll : 0));
      }

      goTo(position, instant = false) {
        const target = Math.max(0, Math.min(this.maxScroll, position));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.rtl ? -target : target, behavior: instant || reducedMotion ? 'auto' : 'smooth' });
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
        this.needsMeasure = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z12-native-sharing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('z12-native-share')) {
  customElements.define('z12-native-share', class extends HTMLElement {
    connectedCallback() {
      if (this.shareReady) return;
      this.shareReady = true;
      this.querySelector('[data-z12-share-input]').value = this.currentUrl();
      this.querySelector('[data-z12-share-copy]').hidden = false;
      this.querySelector('[data-z12-share-native]').hidden = typeof navigator.share !== 'function';
      this.addEventListener('click', async (event) => {
        const target = event.target.closest('button');
        if (!target || !this.contains(target)) return;
        const status = this.querySelector('[data-z12-share-status]');
        const shareUrl = this.currentUrl();
        this.querySelector('[data-z12-share-input]').value = shareUrl;
        status.textContent = '';
        if (target.hasAttribute('data-z12-share-native')) {
          try { await navigator.share({title: this.dataset.title, url: shareUrl}); }
          catch (error) { if (error.name !== 'AbortError') this.manualCopy(); }
        } else if (target.hasAttribute('data-z12-share-copy')) {
          this.manualCopy();
          try {
            if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(shareUrl);
          } catch (_) {}
        }
      });
    }
    currentUrl() {
      const url = new URL(this.dataset.url, window.location.origin);
      url.search = '';
      url.hash = '';
      return url.href;
    }
    manualCopy() {
      this.querySelector('[data-z12-share-manual]').hidden = false;
      const input = this.querySelector('[data-z12-share-input]');
      input.value = this.currentUrl();
      input.focus();
      input.select();
      this.querySelector('[data-z12-share-status]').textContent = this.dataset.manual;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z12-native-works-gallery"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('z12-works-gallery')) {
    customElements.define('z12-works-gallery', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.init();
          if (!this.observer) {
            this.observer = new MutationObserver(() => {
              if (!this.isConnected) return;
              this.clearBindings();
              this.init();
            });
            this.observer.observe(this, { childList: true, subtree: true });
          }
        });
      }
      clearBindings() {
        this.controller?.abort(); this.controller = null;
        this.cards = []; this.tabs = []; this.cardsById = null; this.tabsById = null; this.tablist = null;
      }
      init() {
        if (!this.isConnected || this.controller) return;
        this.tabs = Array.from(this.querySelectorAll('[data-gallery-tab]'));
        this.cards = Array.from(this.querySelectorAll('[data-gallery-item]'));
        this.tablist = this.querySelector('[data-gallery-tabs]');
        this.cardsById = new Map(this.cards.map(card => [card.dataset.blockId, card]));
        this.tabsById = new Map(this.tabs.map(tab => [tab.dataset.blockId, tab]));
        if (!this.tabs.length || !this.tablist || this.tabs.some(tab => !this.cardsById.has(tab.dataset.blockId))) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        document.addEventListener('shopify:section:load', event => {
          if (event.target === this || event.target.contains?.(this)) {
            this.clearBindings(); this.init();
          }
        }, options);
        this.tablist.addEventListener('click', event => {
          const tab = event.target.closest('[data-gallery-tab]');
          if (tab && this.tabsById.get(tab.dataset.blockId) === tab) this.activate(tab.dataset.blockId);
        }, options);
        this.tablist.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-gallery-tab]');
          if (!tab || !this.tabs.includes(tab) || event.altKey || event.ctrlKey || event.metaKey) return;
          const index = this.tabs.indexOf(tab);
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(this.tabs[next].dataset.blockId);
          this.tabs[next].focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target) && this.cardsById.has(event.detail?.blockId)) this.activate(event.detail.blockId);
        }, options);
        this.activate(this.tabsById.has(this.dataset.activeBlock) ? this.dataset.activeBlock : this.tabs[0].dataset.blockId);
      }
      activate(blockId) {
        if (!this.cardsById?.has(blockId) || !this.tabsById?.has(blockId)) return;
        this.cards.forEach(card => {
          const active = card.dataset.blockId === blockId;
          card.hidden = !active; card.inert = !active;
          card.dataset.galleryActive = String(active);
          card.style.setProperty('display', active ? 'block' : 'none', 'important');
        });
        this.tabs.forEach(tab => {
          const active = tab.dataset.blockId === blockId;
          tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        });
        this.dataset.activeBlock = blockId;
        const tab = this.tabsById.get(blockId), list = this.tablist;
        const left = tab.offsetLeft, right = left + tab.offsetWidth;
        if (left < list.scrollLeft) list.scrollLeft = left;
        else if (right > list.scrollLeft + list.clientWidth) list.scrollLeft = right - list.clientWidth;
      }
      disconnectedCallback() {
        this.observer?.disconnect(); this.observer = null;
        this.clearBindings();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
